export const MODAL_TYPE_MANAGE_CATEGORY_MEMBERS = 'manage-category-members';
export const MODAL_TYPE_MANAGE_CATEGORY_MEMBERS_SM = 'manage-category-members-sm';
export const MODAL_TYPE_MANAGE_CATEGORY_MEMBERS_BADGES = 'manage-category-members-badges';
export const MODAL_TYPE_MANAGE_CATEGORY_MEMBERS_ROLES = 'manage-category-members-roles';
export const MODAL_TYPE_MANAGE_CATEGORY_MEMBERS_PLANS = 'manage-category-members-plans';
